const spliceGMT = (timezoneStr?: string) => {
  if (!timezoneStr) {
    return '';
  }
  const timezone = timezoneStr.split(')')[0].replace('(', '');
  return timezone;
};

export { spliceGMT };
